import { render, staticRenderFns } from "./select-send-message.vue?vue&type=template&id=6786343b&scoped=true&"
import script from "./select-send-message.vue?vue&type=script&lang=js&"
export * from "./select-send-message.vue?vue&type=script&lang=js&"
import style0 from "./select-send-message.vue?vue&type=style&index=0&id=6786343b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786343b",
  null
  
)

export default component.exports